import { useMemo } from 'react'
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'
import { useAuth } from '../../components/AuthProvider'
import ScannerGatewayPanel from '../../components/integrations/ScannerGatewayPanel'
import GcpDiscoveryPanel from '../../components/integrations/GcpDiscoveryPanel'
import { Bot, Cloud, Gauge, Radar } from 'lucide-react'
import { useI18n } from '../../i18n'
import { PageLayout } from '../../layouts/PageLayout'
import { ComplianceCenterNavTabs } from '../../components/compliance-center/ComplianceCenterNavTabs'
import { featureFlags } from '../../config/featureFlags'
import { GCP_SECTIONS, INTEGRATION_SECTIONS, SCANNER_SECTIONS } from './integrationsRoutes.mjs'

const ICONS = {
  overview: <Gauge size={16} aria-hidden />,
  ai: <Bot size={16} aria-hidden />,
  scanners: <Radar size={16} aria-hidden />,
  'google-cloud': <Cloud size={16} aria-hidden />,
}

export function IntegrationsScannerRoute() {
  const { token } = useAuth()
  const { scanner } = useParams()
  if (scanner && !SCANNER_SECTIONS.includes(scanner)) {
    return <Navigate to="/integrations/scanners" replace />
  }
  return <ScannerGatewayPanel token={token || ''} />
}

export function IntegrationsCloudRoute() {
  const { token } = useAuth()
  const { section } = useParams()
  if (section && !GCP_SECTIONS.includes(section)) {
    return <Navigate to="/integrations/google-cloud/connection" replace />
  }
  return <GcpDiscoveryPanel token={token || ''} />
}

export default function IntegrationsLayout() {
  const { t } = useI18n()
  const location = useLocation()
  const sections = useMemo(
    () => [
      {
        key: 'integrations',
        label: t('integrations.nav.group', 'Integrations'),
        items: INTEGRATION_SECTIONS.map((item) => ({
          key: item.key,
          to: item.path,
          label:
            item.key === 'overview'
              ? t('integrations.nav.overview', 'Overview')
              : item.key === 'ai'
                ? t('integrations.nav.ai', 'AI Providers')
                : item.key === 'scanners'
                  ? t('integrations.nav.scanners', 'Scanners')
                  : t('integrations.nav.googleCloud', 'Google Cloud'),
          icon: ICONS[item.key],
        })),
      },
    ],
    [t],
  )

  if (location.pathname === '/integrations') {
    return <Navigate to="/integrations/overview" replace />
  }

  return (
    <PageLayout pageScope="integrations-page" title={t('nav.integrations', 'Integrations')}>
      <ComplianceCenterNavTabs
        sections={sections}
        variant={featureFlags.ENTERPRISE_OPERATIONAL_UX_V1 ? 'enterprise' : 'default'}
        ariaLabel={t('integrations.nav.label', 'Integration sections')}
      />
      <Outlet />
    </PageLayout>
  )
}
